<template>
    <div id="returnGoodsManage">
        <el-row class="clearfix">
            <el-col class="fr" :span="1">
                <i class="el-icon-refresh" style="font-size: 25px;cursor: pointer;" @click="refresh()"></i>
            </el-col>
        </el-row>
        <el-col class="fl searthPart" style="width: 20%;">
            <el-form ref="searchForm" :model="searchForm" label-width="75px" :label-position="labelPosition">
                <el-form-item label-width="0px">
                    <el-date-picker
                        style="width: 100%;"
                        v-model="valueTime1"
                        value-format="yyyy-MM-dd"
                        @change="getChangeDate"
                        type="daterange"
                        range-separator="-"
                        start-placeholder="开始"
                        end-placeholder="结束">
                    </el-date-picker>
                </el-form-item>
                <el-input clearable v-model.trim="searchForm.code" placeholder="请输入采购退货编号" style="margin-bottom: 15px;"></el-input>
                <el-input clearable v-model.trim="searchForm.pCode" placeholder="请输入采购订单编号" style="margin-bottom: 15px;"></el-input>
                <el-input clearable v-model.trim="searchForm.storageCode" placeholder="请输入出入库单号" style="margin-bottom: 15px;"></el-input>
                <el-select filterable style="margin-bottom: 15px;width:100%" clearable v-model="searchForm.supplierName" placeholder="请选择供应商">
                    <el-option v-for="(item,index) in supplierData" 
                        :label="item.supplierName" 
                        :value="item.supplierName" 
                        :key="index">
                    </el-option>
                </el-select>
                <el-button type="success" @click="onSubmit()" style="width:100%;margin-top: 20px;">检索采购退货单</el-button>
            </el-form>
        </el-col>
        <el-col class="fr" style="width: 78%;">
            <el-card class="box-card fr" style="width: 100%;">
                <el-table
                    :data="returnData"
                    border
                    :header-cell-style="{'text-align':'center'}"
                    style="width: 100%"
                    @row-click="goToDetail">
                    <el-table-column
                        align="center"
                        prop="code"
                        label="采购退货编号">
                    </el-table-column>
                    <el-table-column
                        align="center"
                        prop="pCode"
                        label="采购订单编号">
                    </el-table-column>
                    <el-table-column
                        align="center"
                        prop="storageCode"
                        label="出入库编号">
                    </el-table-column>
                    <el-table-column
                        align="center"
                        prop="supplierName"
                        label="供应商名称">
                    </el-table-column>
                    <el-table-column
                        align="center"
                        prop="amout"
                        label="退货金额(元）">
                    </el-table-column>
                    <el-table-column
                        align="center"
                        label="退货时间">
                        <template  slot-scope="scope">
                            <span>{{scope.row.createTime | date}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        align="center"
                        prop="reason"
                        label="退货原因">
                    </el-table-column>
                </el-table>
                <!--分页-->
                <el-col :span="24" class="toolbar">
                    <div class="pagination">
                        <el-pagination
                            background
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="pages.page"
                            :page-sizes="[10, 20, 50, 100]"
                            :page-size="pages.pageSize"
                            layout="total, sizes, prev, pager, next,jumper"
                            :total="pages.total">
                        </el-pagination>
                    </div>
                </el-col>
            </el-card>
        </el-col>
    </div>
</template>

<script>
    import {  purchasingReturnList,getsupplierList } from "../../api/api";
    export default {
        name: 'returnGoodsManage',
        components: {},
        data () {
            return {
                valueTime1:[],
                dislogCreate:false,
                labelPosition:'left',
                searchForm:{
                    attribute1:'',
                    attribute2:'',
                    code: '',
                    pCode: '',
                    storageCode: '',
                    supplierName: '',
                },
                //分页变量
                pages:{
                    total: 0,
                    page: 1,
                    pageSize: 10,
                },
                returnData: [],
                orderId:'',
                supplierData:[]
            }
        },
        created:function(){
            this.getPurchasingReturnList()
            this.getsupplierLists();
        },
        methods: {
            //获取供应商列表
            getsupplierLists() {
                let para={
                    supplierCode:"",
                    supplierName:"",
                    contactsName:"",
                    contactsPhone:"",
                    site:"",
                    allottedTime:"",
                    status:1,
                    startRow: 1,
                    pageSize: 10000
                }
                getsupplierList(para).then(res => {
                    if (res.data.status==100) {
                        this.supplierData = res.data.results.list
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            handleSizeChange(val) {
                this.pages.pageSize = val
                this.getPurchasingReturnList()
            },
            handleCurrentChange(Page) {
                this.pages.page = Page
                this.getPurchasingReturnList()
            },
            //清空dialog
            emptyDialog(formName) {
                this.$refs[formName].resetFields();
                this.dislogCreate = false
            },
            getRowDatas(row){
                console.log(row)
            },
            //获取采购退货列表
            getPurchasingReturnList(){
                let para={
                    startRow:this.pages.page,
                    pageSize:this.pages.pageSize,
                    code:this.searchForm.code,
                    pCode:this.searchForm.pCode,
                    storageCode:this.searchForm.storageCode,
                    supplierName:this.searchForm.supplierName,
                    attribute1:this.searchForm.attribute1,
                    attribute2:this.searchForm.attribute2
                };
                purchasingReturnList(para).then(res => {    
                    this.pages.total = res.data.results.total     
                    if (res.data.status==100) {            
                        this.returnData = res.data.results.list
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            getChangeDate(e){
                if(e != null){
                    this.searchForm.attribute1 = this.valueTime1[0]
                    this.searchForm.attribute2 = this.valueTime1[1]
                }else{
                    this.searchForm.attribute1 = ""
                    this.searchForm.attribute2 = ""
                }
            },
            refresh() {
                this.searchForm = {}
                this.getPurchasingReturnList();
            },
            onSubmit() {
                this.getPurchasingReturnList();
            },
            //进入详情页面
            goToDetail(row) {
                this.orderId = row.id
                this.$router.push({
                    path:'/returnGoodsInfo',
                    query:{
                        orderId:this.orderId
                    }
                })
            }
        },
        computed: {},
        watch: {}
    }
</script>

<style type="text/css" scoped>
    #returnGoodsManage{
        font-size: 14px;
    }
    #returnGoodsManage tr.el-table__row{
        cursor: pointer;
    }
    .headerT{
        font-size: 16px;
        margin:0 0 15px 0;
    }
</style>



// WEBPACK FOOTER //
// returnGoodsManage.vue?46a0060e